import React, { Component } from "react";
import { auth } from "../utils/auth";
import { getSucursal, permisions } from "../utils/helpers";
import GIDashboard from "./HomeDashboard/GI/Dashboard";
import VendedoresDashboard from "./HomeDashboard/GI/VendedoresDashboard";
import Programaciones from "./Programaciones";
import Gastos from "./Gastos";
import Solicitudes from "./Solicitudes";
import OrdenesCompra from "./Ingresos/Pedidos";
import CuentasPorCobrar from "./Consultas/CuentasPorCobrar";
import Facturas from "./Ingresos/Facturacion";
import Estudiantes from "./Academico/Estudiantes";
import Evaluaciones from "./Academico/Evaluaciones";
import Inscripciones from "./Academico/Inscripciones";
import Tutores from "./Academico/Tutores";
import FacturacionAcademica from "./Academico/FacturacionAcademica/Create";
import RecibosCocurriculares from "./Academico/Cocurriculares/Recibos";
import InscripcionCocurriculares from "./Academico/Cocurriculares/Inscripcion";
import Salud from "./Salud";
import Visitas from "./Salud/Visitas";
import Pacientes from "./Salud/Pacientes";
import InventarioSalud from "./Salud/Inventario";
import Cuentas from "./Cuentas";
import Cheques from "./Cheques";
import Contratos from "./Contratos";
import CuadreCaja from "./Ingresos/CuadreCaja";
import FacturasRecurrentes from "./Ingresos/FacturacionRecurrente";
import Cotizaciones from "./Ingresos/Cotizacion";
import DespachoFacturas from "./Ingresos/DespachoFacturas";
import Reportes from "./Consultas/Reportes";
import PlantillaImpresion from "./Configuracion/PlantillaImpresion";
import CuentasPorPagar from "./Consultas/CuentasPorPagar";
import RecibosIngreso from "./Consultas/RecibosIngresos";
import NotasCredito from "./Consultas/NotasCredito";
import GIGrupos from "./GI/Grupos";
import GIServidores from "./GI/Servidores";
import GIPrestamos from "./GI/Prestamos";
import Empleados from "./Empleados";
import Tipos from "./Configuracion/Tipos";
import GrupoTipoEmpleados from "./GrupoTipoEmpleados";
import Ausencias from "./Ausencias";
import Cartas from "./Cartas";
import Nominas from "./Nominas";
import DescuentosProgramados from "./DescuentosProgramados";
import Incentivos from "./Incentivos";
import Reclamaciones from "./Reclamaciones";
import Vehiculos from "./Vehiculos";
import Servicios from "./Servicios";
import Rutas from "./Rutas";
import Productos from "./Productos";
import Items from "./Items";
import Compras from "./Compras";
import GastosGenerales from "./GastosGenerales";
import Contactos from "./Contactos";
import Configuracion from "./Configuracion";
import Usuarios from "./Configuracion/Usuarios";
import Sucursales from "./Configuracion/Sucursales";

const MainView = () => {
    const permisosVistaOrdenado = [
        {permiso: permisions.verDashboard,                  vista: GIDashboard},
        {permiso: permisions.dashboardVendedores,           vista: VendedoresDashboard},
        {permiso: permisions.verEvaluaciones,               vista: Evaluaciones,                academico: true},
        {permiso: permisions.verEstudiantes,                vista: Estudiantes,                 academico: true},
        {permiso: permisions.verInscripcion,                vista: Inscripciones,               academico: true},
        {permiso: permisions.verPadrestutores,              vista: Tutores,                     academico: true},
        {permiso: permisions.verFacturacionAcademica,       vista: FacturacionAcademica,        academico: true},
        {permiso: permisions.verCobros,                     vista: RecibosCocurriculares,       academico: true},
        {permiso: permisions.verInscripcionCocurriculares,  vista: InscripcionCocurriculares,   academico: true},
        {permiso: permisions.salud,                         vista: Salud},
        {permiso: permisions.visitaSalud,                   vista: Visitas},
        {permiso: permisions.pacientes,                     vista: Pacientes},
        {permiso: permisions.inventarioSalud,               vista: InventarioSalud},
        {permiso: permisions.verCuentas,                    vista: Cuentas},
        {permiso: permisions.verContabilidad,               vista: Cheques},
        {permiso: permisions.verContratos,                  vista: Contratos},
        {permiso: permisions.verProgramacion,               vista: Programaciones},
        {permiso: permisions.verCuadreCaja,                 vista: CuadreCaja},
        {permiso: permisions.verFacturas,                   vista: Facturas},
        {permiso: permisions.verFacturasRecurrentes,        vista: FacturasRecurrentes},
        {permiso: permisions.verCotizaciones,               vista: Cotizaciones},
        {permiso: permisions.verOrdenesCompra,              vista: OrdenesCompra},
        {permiso: permisions.verPlantillasImpresion,        vista: PlantillaImpresion},
        {permiso: permisions.verDespachoFacturas,           vista: DespachoFacturas},
        {permiso: permisions.verReportes,                   vista: Reportes},
        {permiso: permisions.verCuentasPorCobrar,           vista: CuentasPorCobrar},
        {permiso: permisions.verCuentasPorPagar,            vista: CuentasPorPagar},
        {permiso: permisions.verRecibosIngreso,             vista: RecibosIngreso},
        {permiso: permisions.verNotasCredito,               vista: NotasCredito},
        {permiso: permisions.verGiGrupos,                   vista: GIGrupos},
        {permiso: permisions.verGiServidores,               vista: GIServidores},
        {permiso: permisions.verGiPrestamos,                vista: GIPrestamos},
        {permiso: permisions.verEmpleados,                  vista: Empleados},
        {permiso: permisions.verTipos,                      vista: Tipos},
        {permiso: permisions.verGrupoTiposEmpleados,        vista: GrupoTipoEmpleados},
        {permiso: permisions.verAusencias,                  vista: Ausencias},
        {permiso: permisions.verCartas,                     vista: Cartas},
        {permiso: permisions.verNomina,                     vista: Nominas},
        {permiso: permisions.verDescuentos,                 vista: DescuentosProgramados},
        {permiso: permisions.verIncentivos,                 vista: Incentivos},
        {permiso: permisions.verSolicitudes,                vista: Solicitudes},
        {permiso: permisions.verReclamaciones,              vista: Reclamaciones},
        {permiso: permisions.verVehiculos,                  vista: Vehiculos},
        {permiso: permisions.verServicios,                  vista: Servicios},
        {permiso: permisions.verRutas,                      vista: Rutas},
        // {permiso: permisions.verInventario,                 vista: Items},
        // {permiso: permisions.editarInventario,              vista: Items},
        {permiso: permisions.verProductos,                  vista: Productos},
        {permiso: permisions.editarProductos,               vista: Productos},
        {permiso: permisions.verCompras,                    vista: Compras},
        {permiso: permisions.verGastos,                     vista: Gastos},
        {permiso: permisions.verGastosGenerales,            vista: GastosGenerales},
        {permiso: permisions.verContactos,                  vista: Contactos},
        {permiso: permisions.verConfiguracion,              vista: Configuracion},
        {permiso: permisions.editarUsuarios,                vista: Usuarios},
        {permiso: permisions.editarSucursales,              vista: Sucursales},
    ];

    const user = auth.getUser();
    const sucursalActual = user.sucursales.find(s => s.id === user.sucursalActual);

    for (const PV of permisosVistaOrdenado) {
        if (PV.academico && sucursalActual?.tipo !== 'educativa') continue;

        if (auth.can(PV.permiso)) return <PV.vista />;
    }
    

    if (auth.is("digitador")) return <Programaciones />;
    
    if (auth.is("gasto")) return <Gastos />;
    if (auth.is("solicitudes")) return <Solicitudes />;
    if (auth.is("vendedor") || auth.is('vendedor-cliente')) return <OrdenesCompra />;
    if (auth.is('cobrador')) return <CuentasPorCobrar />;
    if (auth.is("vendedor-factura") || auth.is("vendedor-factura-orden_compra")) return <Facturas />;
    
    
    if (auth.can(permisions.dashboardVendedores)) return <VendedoresDashboard />;
    return <GIDashboard />; //NewDashboard;
};

export default MainView;